import React from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

const classnames = require('classnames');

const parseRefinementOptions = items => {
    const options = [];

    items.forEach(item => {
        const { label } = item;

        if (label.includes(' > ')) {
            return;
        }

        options.push({
            ...item,
            children: [],
        });
    });

    items.forEach(item => {
        const { label } = item;

        if (!label.includes(' > ')) {
            return;
        }

        const labelParsed = label.split(' > ');
        const parentIndex = options.findIndex(option => option.label === labelParsed[0]);

        if (parentIndex < 0) {
            return;
        }

        options[parentIndex].children.push(item);
    });

    return options;
};

const HierarchicalMenuMulti = props => {
    const { items, refine } = props;
    const filterOptions = parseRefinementOptions(items);

    return (
        <div className="ais-HierarchicalMenu">
            <ul className="ais-HierarchicalMenu-list">
                {filterOptions.map(filterOption => {
                    const parentClasses = classnames('ais-HierarchicalMenu-item', {
                        'ais-HierarchicalMenu-item--selected ais-HierarchicalMenu-item--parent': filterOption.isRefined,
                    });

                    return (
                        <li key={filterOption.label} className={parentClasses}>
                            <div className="ais-HierarchicalMenu-item-content">
                                {/* Parent checkbox - handle independently */}
                                <span className="ais-HierarchicalMenu-checkbox">
                                    <input
                                        type="checkbox"
                                        checked={filterOption.isRefined}
                                        onChange={() => {
                                            // Toggle refinement for the parent item
                                            const refinements = [];
                                            const children = filterOption.children.map(child => child.label);

                                            filterOption.value.forEach(value => {
                                                if (!children.includes(value)) {
                                                    refinements.push(value);
                                                }
                                            });

                                            refine(refinements);
                                        }}
                                    />
                                </span>

                                {/* Parent label as clickable link */}
                                <a
                                    className="ais-HierarchicalMenu-link"
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault();

                                        // Refine parent and unrefine all children
                                        const refinements = [];
                                        const children = filterOption.children.map(child => child.label);

                                        filterOption.value.forEach(value => {
                                            if (!children.includes(value)) {
                                                refinements.push(value);
                                            }
                                        });

                                        refine(refinements);
                                    }}
                                >
                                    <span className="ais-HierarchicalMenu-label">{filterOption.label}</span>{' '}
                                    <span className="ais-HierarchicalMenu-count">{filterOption.count}</span>
                                </a>
                            </div>

                            {/* Child items */}
                            {filterOption.children.length > 0 && (
                                <ul
                                    className="ais-HierarchicalMenu-list ais-HierarchicalMenu-list--child"
                                    style={{
                                        display:
                                            filterOption.isRefined ||
                                            filterOption.children.find(child => child.isRefined)
                                                ? 'block'
                                                : 'none',
                                    }}
                                >
                                    {filterOption.children.map(filterOptionChild => {
                                        const childClasses = classnames('ais-HierarchicalMenu-item', {
                                            'ais-HierarchicalMenu-item--selected': filterOptionChild.isRefined,
                                        });

                                        const childLabelCode = filterOptionChild.label.split(' > ')[1];
                                        const childLabelParts = childLabelCode.split('-');
                                        const childLabel = childLabelParts.length > 0 ? childLabelParts[1] : childLabelParts[0];

                                        return (
                                            <li key={filterOptionChild.label} className={childClasses}>
                                                <div className="ais-HierarchicalMenu-item-content">
                                                    {/* Child checkbox - handle independently */}
                                                    <span className="ais-HierarchicalMenu-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            checked={filterOptionChild.isRefined}
                                                            onChange={() => {
                                                                // Toggle refinement for the child item
                                                                refine(
                                                                    filterOptionChild.value.filter(
                                                                        value => value !== filterOption.label
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </span>

                                                    {/* Child label as clickable link */}
                                                    <a
                                                        className="ais-HierarchicalMenu-link"
                                                        href="#"
                                                        onClick={e => {
                                                            e.preventDefault();

                                                            // Refine child and unrefine parent
                                                            refine(
                                                                filterOptionChild.value.filter(
                                                                    value => value !== filterOption.label
                                                                )
                                                            );
                                                        }}
                                                    >
                                                        <span
                                                            className="ais-HierarchicalMenu-label">{childLabel}</span>{' '}
                                                        <span
                                                            className="ais-HierarchicalMenu-count">{filterOptionChild.count}</span>
                                                    </a>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

HierarchicalMenuMulti.propTypes = {
    items: PropTypes.array.isRequired,
    refine: PropTypes.func.isRequired,
};

export default connectRefinementList(HierarchicalMenuMulti);
